import moment from 'moment';
import actionTypes from './actions/actiontypes';

const {
  REQUEST_ACTIVITY_LOGS,
  RECEIVE_ACTIVITY_LOGS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
  FILTER_LOGS
} = actionTypes;

const activityLogsReducer = (state = {
  isFetchingList: false,
  activityLogs: [],
  hasServerError: false,
  errors: {},
  success: false,
  msg: ''
}, action) => {
  switch (action.type) {
   
    case REQUEST_ACTIVITY_LOGS:
      return Object.assign({}, state, {
        isFetchingList: true,
        hasServerError: false,
        errors: {},
        success: false,
        msg: ''
      });
    case CLEAR_ERRORS:
        return Object.assign({}, state, {
          hasServerError: false,
          errors: {},
          success: false,
          msg: ''
        });
    case RECEIVE_ACTIVITY_LOGS:
      return Object.assign({}, state, {
        isFetchingList: false,
        activityLogs: action.activityLogs
      });
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasServerError: true,
        errors: action.errors,
        success: false
      });
    case FILTER_LOGS: 
    let activityLogs = state.activityLogs;
    activityLogs = activityLogs.map((log) => {
      const startDateTime = new Date(action.startDate.toDate()).getTime();
      const endDateTime = new Date(action.endDate.toDate()).getTime();
      const logTime = new Date(log.datetime).getTime();

      if (log.is_webinar) {
        log.show =
          action.webinar &&
          (logTime >= startDateTime && logTime <= endDateTime) &&
          (action.keyword === "" ||
            log.room_name.toLowerCase().includes(action.keyword.toLowerCase()) ||
            log.name.toLowerCase().includes(action.keyword.toLowerCase()));
      }

      if (!log.is_webinar) {
        log.show =
          action.conference &&
          (logTime >= startDateTime && logTime <= endDateTime) &&
          (action.keyword === "" ||
            log.room_name.toLowerCase().includes(action.keyword.toLowerCase()) ||
            log.name.toLowerCase().includes(action.keyword.toLowerCase()));
      }

      return log;
    });
    return Object.assign({}, state, {
      activityLogs,
    });
    default:
      return state;
  }
};

export default activityLogsReducer;



// WEBPACK FOOTER //
// src/routes/ActivityLogs/reducer.js